import store from "../store/index";
import { setTheme } from "../theme/theme";

// 判断是安卓还是ios
export default function appDown() {
  // setTheme('white');
  // store.commit("setToken", '4b526c2f79386a6a666d6e67464a4a3865507974783767316756564e396c43554a6b56505867423431366c674931494e572b75764e773d3d');
  let u = navigator.userAgent;
  // android 终端
  let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
  // ios 终端
  let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  if (isiOS) {
    window["getToken"] = (value) => {
      let flag = value.split(",");
      console.log('ssssss')
      console.log(flag)
      console.log('ssssss')
      store.commit("setPhone", flag[0]); // 手机号
      store.commit("setToken", flag[1]); // token
      console.log('ios传递过来的桩号'+ flag[2])
      if (flag[2] !== "") {
        store.commit("setCurrentPileCode", flag[2]); // 桩号
      }
      if (flag[3] && flag[3] !== "") {
        // 获取主题
        setTheme(flag[3]);
      } else {
        setTheme("white");
      }
    };
  } else if (isAndroid) {
    getToken().then((res) => {
      store.commit("setToken", res);
    });
    getPhone().then((re) => {
      store.commit("setPhone", re);
    });
    getCurrentPileCode().then((res) => {
      console.log('安卓传递过来的桩号' + res)
      store.commit("setCurrentPileCode", res);
    });
    // 获取主题
    getTheme().then((r) => {
      if (r && r === "white") {
        setTheme("white");
      } else {
        setTheme("dark");
      }
    });
  }
}

// 安卓获取 token
function getToken() {
  return new Promise((resolve, reject) => {
    resolve(window.jsBridge.getToken());
  });
}

// 安卓获取 电话号码
function getPhone() {
  return new Promise((resolve, reject) => {
    resolve(window.jsBridge.getPhone());
  });
}

// 安卓获取 桩号
function getCurrentPileCode() {
  return new Promise((resolve, reject) => {
    resolve(window.jsBridge.getCurrentPileCode());
  });
}

// 安卓获取 主题
function getTheme() {
  return new Promise((resolve, reject) => {
    resolve(window.jsBridge.getAppTheme());
  });
}

appDown();
